import AdminPageApproveLdsTable from "./AdminPageApproveLdsTable";
import { Card } from "react-bootstrap";

function AdminPageApproveLds() {
  return (
    <Card
      className="mb-3"
      style={{
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <Card.Header
        style={{
          background: "#2D083F",
          color: "white",
          borderRadius: "10px 10px 0 0",
        }}
      >
        <Card.Title className="mb-0" style={{ color: "white" }}>
          LD Approval
        </Card.Title>
      </Card.Header>
      <Card.Body style={{ background: "#FFFFFF", padding: "0" }}>
        <AdminPageApproveLdsTable />
      </Card.Body>
    </Card>
  );
}

export default AdminPageApproveLds;
